import React, { useState } from 'react';
import get from 'lodash/get';
import padStart from 'lodash/padStart';
import moment from 'moment';

import { env, lang } from '~/commons/config';
import ListResource from './ListResource.jsx';
import ListCompSelect from './ListCompSelect.jsx';

const api = 'api/quiz/scores';

const ListScores = () => {
  const [district, setDistrict] = useState('');
  const [qualified, setQualified] = useState(1);
  const [compFilter, setCompFilter] = useState({});
  const { competition } = compFilter;

  const filter = { ...compFilter };

  if (competition) filter.qualified = qualified;
  if (district) filter.district = district;

  return (
    <ListResource
      {...{
        searchable: true,
        api,
        sort: { 'score.totalScore': -1 },
        filter,
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: true,
        },
        cols: [
          {
            key: 'title.en',
            children: 'School',
            sortable: true,
            getter: (v, r) => lang(get(r, 'title')),
          },
          {
            key: 'district',
            sortable: true,
            getter: (v) => env.districts[v].zhhk,
          },
          {
            key: 'score.totalScore',
            children: 'First 20 Total Score',
            sortable: true,
          },
          {
            key: 'score.avgScore',
            children: 'First 20 Avg. Score',
            sortable: true,
            getter: (v) => (v ? Math.round(v * 100) / 100 : ''),
          },
          {
            key: 'score.avgDuration',
            children: 'First 20 Avg. Time Spent',
            sortable: true,
            getter: (v) => {
              if (!v) return '';

              const d = moment.duration(v, 'ms');

              return `${
                padStart(d.minutes(), 2, 0)
              }:${
                padStart(d.seconds(), 2, 0)
              }.${
                padStart(Math.round(d.milliseconds() / 10), 2, 0)
              }`;
            },
          },
          {
            key: 'studentCount',
            children: 'Student Count',
            sortable: true,
          },
          {
            key: 'students.enrollmentCount',
            children: 'Account Count',
            sortable: true,
          },
          {
            key: 'answers.count',
            children: 'Total Participants No.',
            sortable: true,
            getter: (v) => v || 0
          },
          {
            key: 'enrollment',
            sortable: true,
            getter: (v) => (v !== 'na'
              ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'
            ),
          },
          {
            key: 'enrollmentScore',
            children: 'Enrollment Score',
            sortable: true,
            getter: (v) => (v !== 'na' ? v : 'N/A'),
          },
          {
            key: 'participation',
            sortable: true,
            getter: (v) => (v !== 'na'
              ? `${Math.round(v * 100 * 100) / 100}%` : 'N/A'
            ),
          },
          {
            key: 'participationScore',
            children: 'Participation Score',
            sortable: true,
            getter: (v) => (v !== 'na' ? v : 'N/A'),
          },
          {
            key: 'fullScore',
            children: 'Total Score',
            sortable: true,
            getter: (v) => (v !== 'na' ? Math.round(v * 100) / 100 : 'N/A'),
          },
        ],
        ctrls: [
          <ListCompSelect
            key={0}
            value={compFilter}
            onChange={setCompFilter}
          />,
          ...(competition ? [
            <select
              className="custom-select"
              key={1}
              value={qualified}
              onChange={(e) => setQualified(e.target.value)}
            >
              <option value={1}>Qualified</option>
              <option value={0}>Unqualified</option>
            </select>,
          ] : []),
          <select
            className="custom-select"
            key={2}
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
          >
            <option value="">All Districts</option>
            {Object.keys(env.districts).map((d) => (
              <option key={d} value={d}>
                {env.districts[d].zhhk}
              </option>
            ))}
          </select>,
        ],
      }}
    />
  );
};

export default ListScores;
